import * as React from "react";
import PropTypes from "prop-types";
import { Control, Label, Select } from "rbx";

import { useLazyQuery } from "react-apollo";

import gql from "graphql-tag";

import moment from "moment";

const GET_TRIPS_QUERY = gql`
  query GET_TRIPS_QUERY($where: OrderWhereInput) {
    Orders(where: $where) {
      RecId
      Trip
    }
  }
`;

function TripSelect({
  label,
  name,
  value,
  onChange,
  disabled,
  showLabel,
  pickupDate,
  pickupLocation
}) {
  const [trips, setTrips] = React.useState([]);

  const [getTrips, { data: TripsData }] = useLazyQuery(GET_TRIPS_QUERY);

  React.useEffect(() => {
    if (moment(pickupDate).isValid() && pickupLocation) {
      getTrips({
        variables: {
          where: {
            TripKey_startsWith: `${moment(pickupDate).format(
              "YYYY-MM_DD"
            )}_${pickupLocation}`
          }
        },
        fetchPolicy: "cache-and-network"
      });
    }
  }, [getTrips, pickupDate, pickupLocation]);

  React.useEffect(() => {
    const orders = TripsData?.Orders;
    if (orders) {
      setTrips(
        [...new Set(orders.map(x => x.Trip))]
          .filter(x => !!x)
          .sort((a, b) => {
            if (a > b) return 1;
            if (b > a) return -1;
            return 0;
          })
      );
    }
  }, [TripsData, pickupDate, pickupLocation]);

  const handleChange = e => {
    onChange(e.target.name, e.target.value);
  };

  return (
    <Control expanded>
      {showLabel && <Label>{label}</Label>}
      <Select.Container fullwidth>
        <Select
          disabled={disabled}
          name={name}
          value={value}
          onChange={handleChange}
        >
          <Select.Option value="" />
          {trips.map(trip => (
            <Select.Option
              key={trip}
              value={trip}
            >{`Trip ${trip}`}</Select.Option>
          ))}
        </Select>
      </Select.Container>
    </Control>
  );
}

TripSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  showLabel: PropTypes.bool,
  pickupDate: PropTypes.string,
  disabled: PropTypes.bool,
  pickupLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TripSelect.defaultProps = {
  label: "",
  name: "",
  value: "",
  onChange: () => {},
  showLabel: true,
  pickupDate: "",
  pickupLocation: "",
  disabled: false
};
export default TripSelect;
